const {
  selectedToOnHold,
  actionOnFinalHold,
  getOpsHead,
  movetofinalround,
  getmarksdetails,
  getConfig,
  getTeamsToken,
  getCandidateSummary,
  panelFeedbackForm,
  getfeedbackforms,
  getScheduledInterview,
  triggerAssessment,
  savefeedbackform,
  notInterestedCandidate,
  addScheduleInterview,
  getFeedbackHistory,
  getResume,
  getVcclData,
  cancelmeeting,
  cancelVccl,
  rescheduleVccl,
} = require("../../utils/apiFunctions");
const axios = require("axios");
const { clearFeedbackForm, copyToClipboard } = require("./helpers");
const { downloadResumeFile } = require("../../utils/download.js");
// POST DIRECT ON-HOLD DATA
const directOnHold = async (vueObj) => {
  let payload = {
    candidateID: vueObj.finalSelectedCandidate.candidateID,
    jobID: vueObj.$route.query.jobID,
    customerID: vueObj.$route.query.customerID,
    action: "onHold",
  };
  const response = await selectedToOnHold(payload);
  if (response.status == 200) {
    vueObj.successModal("Candidate moved to on-hold");
    vueObj.closeFinalHold();
    if (vueObj.$route.name == "JdDetails") {
      vueObj.getJobDetails();
    } else {
      vueObj.getCandidates();
    }
  } else {
    vueObj.errorModal(response.data.data.Details);
  }
};

// POST FINAL ON-HOLD ACTION
const actionOnnFinalHold = async (vueObj) => {
  if (vueObj.finalSelectedCandidate.select == null) {
    vueObj.errorModal("Please choose one option");
    return;
  }
  let payload = {
    customerID: vueObj.$route.query.customerID,
    jobID: vueObj.$route.query.jobID,
    candidateID: vueObj.finalSelectedCandidate.candidateID,
    select: vueObj.isFinalSelected(),
    remarks: "",
  };
  const response = await actionOnFinalHold(payload);
  if (response.status == 200) {
    if (vueObj.finalSelectedCandidate.select === "true") {
      vueObj.successModal("Candidate is selected");
    } else {
      vueObj.successModal("Candidate is rejected");
    }
    vueObj.closeFinalAction();
    if (vueObj.$route.name == "JdDetails") {
      vueObj.getJobDetails();
    } else {
      vueObj.getCandidates();
    }
  } else {
    vueObj.errorModal(response.data.data.Detail);
  }
};
// GET LIST OF OPSHEAD FOR FINAL APPROVAL VIA KANBAN
const getopsHead = async (vueObj) => {
  let payload = {
    searchQuery: vueObj.searchQuery,
    licenseKey: vueObj.licenseKey,
  };
  const response = await getOpsHead(payload);
  if (response.status == 200) {
    vueObj.opsHeadList = response.data.data;
    vueObj.opsHeadName = vueObj.opsHeadList.map((item) => item.username);
  }
};
const sendForApproval = async (vueObj) => {
  try {
    vueObj.$v.select_opsHeadName.$touch();
    vueObj.$v.opsHeadRemarks.$touch();
    if (
      !vueObj.$v.opsHeadRemarks.required ||
      !vueObj.$v.select_opsHeadName.required
    ) {
      vueObj.errorModal("Please enter all the details");
      return;
    }
    let payload = {
      candidateID: vueObj.activeCandidate.candidateID,
      customerID: vueObj.$route.query.customerID,
      jobID: vueObj.$route.query.jobID,
      approverUserID: vueObj.approverUserID,
      recruiterRemarks: vueObj.opsHeadRemarks,
    };
    const res = await movetofinalround(payload);
    if (res.status == 200) {
      vueObj.select_opsHeadName = "";
      vueObj.opsHeadRemarks = "";
      vueObj.ScheduleInterview.selectCand = false;

      vueObj.$bvModal.hide("SelOpsheadFinal");
      vueObj.$bvModal.hide("assesmentmodal");
      vueObj.$bvModal.hide("scheduleModal");
      vueObj.$bvModal.hide("feedback");
      if (vueObj.$route.name == "JdDetails") {
        vueObj.getJobDetails();
      } else {
        vueObj.getCandidates();
      }
      vueObj.$v.$reset();
    } else {
      vueObj.$bvModal.hide("SelOpsheadFinal");
      vueObj.errorModal(res.data.data.Detail);
      vueObj.feedback.recommendation = "";
      vueObj.$v.$reset();
    }
  } catch (error) {
    vueObj.$bvModal.hide("SelOpsheadFinal");
    vueObj.errorModal(
      "Candidate details failed to be sent to Ops-head for Approval"
    );
    vueObj.$v.$reset();
  }
  vueObj.select_opsHeadName = "";
  vueObj.opsHeadRemarks = "";
  vueObj.selectrec = "";
  vueObj.feedback.recommendation = "";
};
const assignMarksSuccess = async (vueObj, data) => {
  if (data.assessmentResponse.evaluationStatus) {
    let payload;
    if (data.kanbanInterviewID) {
      payload = data.kanbanInterviewID;
    } else {
      payload = data.interviewID;
    }

    const res = await getmarksdetails(payload);

    if (res.status == 200) {
      vueObj.marksdetailsSuccess = res.data.data;

      vueObj.marksdetailsSuccess.assessmentResponse.forEach((value, index) => {
        if (index == 0) {
          value.viewdetails = true;
        } else {
          value.viewdetails = false;
        }
      });
    }
    vueObj.$bvModal.show("totalmarks");
  }
};
const closemarksSuccess = async (vueObj, index) => {
  vueObj.marksdetailsSuccess.assessmentResponse[index].viewdetails =
    !vueObj.marksdetailsSuccess.assessmentResponse[index].viewdetails;
  vueObj.$forceUpdate();
};
const rejectedscheduleInterviewModal = async (vueObj, objModal) => {
  vueObj.confirmmodal = false;
  if (objModal.rejectedroundselected.type == "f2f") {
    vueObj.ScheduleInterview.roundlevel = objModal.rejectedroundselected.id;

    vueObj.rejectscheduleinterview = true;
    vueObj.ScheduleInterview.schedulename = "Schedule Interview";
    const emailDomain = vueObj.roleValues.email.split("@")[1];
    if (emailDomain == "simplify3x.com") {
      vueObj.ScheduleInterview.selectedOption = "Microsoft Teams";
      vueObj.ScheduleInterview.withTeams = true;
    } else {
      vueObj.ScheduleInterview.selectedOption = " None";
      vueObj.ScheduleInterview.withTeams = false;
    }

    vueObj.ScheduleInterview.scheduleButton = "Schedule";

    vueObj.ScheduleInterview.jobID = vueObj.$route.query.jobID;
    vueObj.ScheduleInterview.customerID = vueObj.$route.query.customerID;
    vueObj.teamsToken = "";
    vueObj.$store.dispatch("panelVUEX/getPanel");
  } else if (objModal.rejectedroundselected.type == "assesment") {
    const closeTestDateString =
      objModal.rejectedroundselected.config.closeTestdt;
    const closeTestDate = new Date(closeTestDateString);
    const currentDate = new Date();

    const options = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    };
    const formattedCloseTestDate = closeTestDate.toLocaleString(
      "en-US",
      options
    );
    const formattedCurrentDate = currentDate.toLocaleString("en-US", options);

    if (new Date(formattedCloseTestDate) <= new Date(formattedCurrentDate)) {
      objModal.disableShare = true;
    } else {
      objModal.disableShare = false;
    }

    vueObj.rejectsendassessment = true;
    vueObj.selectedAssessment.configId =
      objModal.rejectedroundselected.configID;
    vueObj.selectedAssessment = vueObj.activeCandidate;
    vueObj.configTabIndex = 0;
    const res = await getConfig(objModal.rejectedroundselected.configID);
    vueObj.testConfigData.config = res.data.data.config;
    vueObj.configName = res.data.data.configName;
  }
};

const openAssessmentConfigModal = async (vueObj, Details) => {
  try {
    vueObj.configTabIndex = 0;
    const res = await getConfig(Details.configID);
    vueObj.testConfigData.config = res.data.data.config;
    vueObj.configName = res.data.data.configName;
    vueObj.$bvModal.show("assesmentmodal");
  } catch (error) {
    throw new Error(`Failed! status:${error.status}`);
  }

  vueObj.activeCandidate = Details;
  vueObj.selectedAssessment = Details;
};

const getTeamToken = async (vueObj) => {
  vueObj.showSpinner = true;
  try {
    const response = await getTeamsToken();
    if (response.status == 200) {
      vueObj.teamsToken = await response.data.token;
      createmeeting(vueObj);
    } else {
      vueObj.showSpinner = false;
      vueObj.errorModal("Create meeting failed, try again!");
    }
  } catch (error) {
    vueObj.showSpinner = false;
    vueObj.errorModal("Create meeting failed, try again!");
    console.error(error);
  }
};
// Download Profile Pdf Api
const candidateSummary = async (vueObj, data) => {
  vueObj.showSpinner = true;
  try {
    let payload = {
      jobID: vueObj.$route.query.jobID,
      emailID: data.email,
    };
    const res = await getCandidateSummary(payload);
    if (res.status == 200) {
      window.open(res.data.data.Detail.file);
      vueObj.showSpinner = false;
    } else {
      vueObj.showSpinner = false;
    }
  } catch (error) {
    vueObj.errorModal("Download failed, Try again!");
    vueObj.showSpinner = false;
    throw new Error(`Failed! status:${error.status}`);
  }
};

const panelDetails = async (vueObj, objModal) => {
  if (vueObj.candidateInterviewRound.externalPanelist.length != 0) {
    vueObj.panelistEmail = vueObj.candidateInterviewRound.externalPanelist;
  } else if (vueObj.candidateInterviewRound.panelist.email != "") {
    vueObj.panelistEmail.push(vueObj.candidateInterviewRound.panelist.email);
  }

  let payload = {
    interviewID: vueObj.activeCandidate.kanbanInterviewID,
    panelEmail: vueObj.panelistEmail,
  };

  const res = await panelFeedbackForm(payload);
  if (res.status == 200) {
    vueObj.panelistEmail = [];
    clearFeedbackForm(vueObj, objModal);
    vueObj.successModal("Reminder has been sent");
  }
};
const exportResume = async (data) => {
  try {
    let payload = {
      candidateID: data.candidateID,
    };
    const res = await getResume(payload);
    if (res.status == 200) {
      const link = res.data.data.resumeLink;
      // implemented bcz once we click on download resume that page shouldn't go blank
      const candidateName = res.data.data.name;

      await downloadResumeFile(link, candidateName);
      // this.successModal("Resume downloaded successfully");
    }
  } catch (error) {
    console.error(error);
  }
};
const openGiveFeedbackModal = async (vueObj, data) => {
  vueObj.tabFIndex = 0;
  vueObj.activeCandidate = data;

  try {
    const response = await getScheduledInterview(
      vueObj.activeCandidate.kanbanInterviewID
    );
    if (response.status == 200) {
      vueObj.candidateInterviewRound = response.data.data;
      vueObj.feedback.externalPanelist = response.data.data.externalPanelist;

      vueObj.feedback.name = vueObj.activeCandidate.name;
      vueObj.feedback.modeOfInterview =
        vueObj.candidateInterviewRound.interviewRound.type;
      if (vueObj.feedback.modeOfInterview === "f2f") {
        vueObj.modeOfInterview = "Face to face";
      } else {
        vueObj.modeOfInterview = "Assessment";
      }
      vueObj.feedback.experience = vueObj.activeCandidate.experince;
      let today = new Date();
      let day = String(today.getDate()).padStart(2, "0");
      let month = String(today.getMonth() + 1).padStart(2, "0");
      let year = today.getFullYear();
      let formattedDate = day + "/" + month + "/" + year;
      vueObj.feedback.evalDate = formattedDate;
      if ("panelist" in vueObj.candidateInterviewRound) {
        vueObj.feedback.panelName =
          vueObj.candidateInterviewRound.panelist.name;
      } else {
        vueObj.feedback.panelName =
          vueObj.candidateInterviewRound.externalPanelist;
      }
      let type = 1;
      const response1 = await getfeedbackforms(
        type,
        vueObj.candidateInterviewRound.interviewRound.feedbackFormID
      );
      if (response1.status == 200) {
        vueObj.feedbackform = response1.data.data;

        for (let i in vueObj.feedbackform.skills) {
          vueObj.feedbackform.skills[i].commenterror = false;
          vueObj.feedbackform.skills[i].markerror = false;
        }
      }
    }

    vueObj.$bvModal.show("feedback");
  } catch (error) {
    console.error(error);
  }
};
const shareTestRej = async (vueObj, objModal) => {
  objModal.showSpinner = true;

  try {
    let payload = {
      panelList: [],
      candidateID: [],
      jobID: "",
      customerID: "",
      level: {},
    };
    payload.candidateID.push(vueObj.activeCandidate.candidateID);
    payload.customerID = vueObj.$route.query.customerID;
    payload.jobID = vueObj.$route.query.jobID;
    payload.level[vueObj.activeCandidate.candidateID] = parseInt(
      objModal.rejectedroundselected.id
    );
    let panel = "cvinfra@simplify3x.com";
    payload.panelList.push(panel);
    const res = await triggerAssessment(payload);
    if (res.status == 200) {
      vueObj.successModal("Assessment Triggered Successfully");
      vueObj.$bvModal.hide("schedrejectedmodal");

      objModal.showSpinner = false;
      objModal.rejectedroundselected = {};

      if (vueObj.$route.name == "JdDetails") {
        vueObj.getJobDetails();
      } else {
        vueObj.getCandidates();
      }
    }
  } catch (error) {
    throw new Error(`Failed! status:${error.status}`);
  }
};
const checkFeedback = async (vueObj, data) => {
  if (vueObj.resumeFiles == "" && vueObj.feedback.recommendation != "NI") {
    data.feedbackerror = true;
  } else {
    data.feedbackerror = false;
  }
};
const getfeedbackDetails = async (vueObj) => {
  if (vueObj.feedback.recommendation === "H") {
    vueObj.successModal("Candidate is moved to on hold");
  } else if (vueObj.feedback.recommendation === "R") {
    vueObj.successModal("Candidate is moved to rejected");
  } else if (vueObj.feedback.recommendation === "NI") {
    vueObj.successModal("Candidate is moved to not interested");
  } else {
    vueObj.successModal("Feedback Given Successfully");
  }
  if (vueObj.$route.name == "JdDetails") {
    vueObj.getJobDetails();
  } else {
    vueObj.getCandidates();
  }
};

const getsavefeedbackResponse = async (vueObj, data) => {
  let form = new FormData();
  let item = vueObj.feedback;
  if (
    vueObj.feedback["candidateImage"] != undefined ||
    vueObj.feedback["candidateImage"] != ""
  ) {
    if (
      data.image == undefined ||
      vueObj.feedback.candidateImage == undefined
    ) {
      delete vueObj.image;
      delete vueObj.feedback.candidateImage;
    } else if (data.image !== "") {
      item["candidateImage"] = data.image;
    }
  }
  if (
    vueObj.feedback["feedbackForm"] != undefined &&
    vueObj.feedback["feedbackForm"] != ""
  ) {
    item["feedbackForm"] = vueObj.resumeFiles;
    item["processedBy"] = "Recruiter";

    delete item.customFeedback;
  } else if (
    vueObj.feedback["customFeedback"] != undefined ||
    vueObj.feedback["customFeedback"] != ""
  ) {
    item["customFeedback"] = JSON.stringify(vueObj.feedback.customFeedback);
    item["processedBy"] = "PanelThruRecruiter";
    delete item.feedbackForm;
  } else {
    delete item.customFeedback;
  }
  item["name"] = vueObj.activeCandidate.name;
  item["interviewID"] = vueObj.activeCandidate.kanbanInterviewID;
  for (let key in item) {
    form.append(key, item[key]);
  }
  const response = await savefeedbackform(form);
  if (response.status == 200) {
    await feedBackOpshead(vueObj, data);
  } else if (
    response.status == 400 ||
    response.status == 500 ||
    response.status == 409
  ) {
    vueObj.errorModal(response.data.data.Detail);
  }
};

const feedBackOpshead = async (vueObj, data) => {
  if (vueObj.feedback.sendOpshead) {
    await sendForApproval(vueObj);
  }
  await getfeedbackDetails(vueObj);
  clearFeedbackForm(vueObj, data);
};

const savefeedback = async (vueObj, data) => {
  try {
    await checkFeedback(vueObj, data);

    vueObj.$v.feedbackform.$touch();
    vueObj.$v.feedback.$touch();

    if (
      (!data.feedbackerror && !vueObj.$v.feedback.$invalid && !data.isFailed) ||
      (!vueObj.$v.feedback.$invalid && !vueObj.$v.feedbackform.skills.$invalid)
    ) {
      vueObj.feedback.customFeedback = vueObj.feedbackform;
      if (!vueObj.activeCandidate.selectionInfo) {
        vueObj.feedback.customFeedback = vueObj.feedbackform;
      } else {
        vueObj.feedback.customFeedback = {
          basicInfo: {
            name: vueObj.feedback.name,
            evalDate: vueObj.feedback.evalDate,
            experience: vueObj.feedback.experience,
            panel: vueObj.feedback.panelName,
          },
        };
      }

      if (vueObj.activeCandidate.kanbanLevel !== "F") {
        vueObj.feedback.customFeedback.basicInfo.evalDate =
          vueObj.feedback.evalDate;
        vueObj.feedback.customFeedback.basicInfo.panel =
          vueObj.feedback.panelName;

        vueObj.feedback.customFeedback.basicInfo.modeOfInterview =
          vueObj.feedback.modeOfInterview;

        vueObj.feedback.customFeedback.basicInfo.name = vueObj.feedback.name;
        vueObj.feedback.customFeedback.basicInfo.experience =
          vueObj.feedback.experience;
        vueObj.feedback.customFeedback.basicInfo.evalDate =
          vueObj.getCurrentDate;
      }
      await getsavefeedbackResponse(vueObj, data);
    } else if (data.isFailed) {
      vueObj.errorModal("Please upload a proper image");
    }
  } catch (error) {
    vueObj.errorModal("Something went wrong");
    console.error(error);
  }
};
const notInterested = async (vueObj) => {
  try {
    vueObj.$v.notInterestedRemarks.$touch();
    if (!vueObj.$v.notInterestedRemarks.$invalid) {
      let data = {
        candidateID: vueObj.notInterestedCandidate.candidateID,
        customerID: vueObj.$route.query.customerID,
        jobID: vueObj.$route.query.jobID,
        recommendation: "NI",
        remarks: vueObj.notInterestedRemarks,
      };
      const response = await notInterestedCandidate(data);
      if (response.status == 200) {
        vueObj.LoaderStatus = false;
        vueObj.successModal("Candidate moved to not intrested");
        if (vueObj.$route.name == "JdDetails") {
          vueObj.getJobDetails();
        } else {
          vueObj.getCandidates();
        }
        vueObj.$bvModal.hide("notInterested");
      }
    }
  } catch (error) {
    vueObj.$bvModal.hide("notInterested");
    vueObj.errorModal("something went wrong");
  }
};
const checkSheduleInterview = async (vueObj, objModal) => {
  if (objModal.rejectedroundselected) {
    vueObj.ScheduleInterview.roundlevel = objModal.rejectedroundselected.id;
  } else {
    vueObj.ScheduleInterview.roundlevel = vueObj.activeCandidate.kanbanLevel;
  }

  if (
    objModal.isExternalEmpty &&
    objModal.isPanelEmpty &&
    vueObj.ScheduleInterview.date != "" &&
    vueObj.ScheduleInterview.startTime != ""
  ) {
    vueObj.ScheduleInterview.errorpanel = true;
  } else if (!objModal.isExternalEmpty || !objModal.isPanelEmpty) {
    vueObj.ScheduleInterview.errorpanel = false;
  }
  if (objModal.isExternalEmpty) {
    delete vueObj.ScheduleInterview.externalPanelist;
  }
  if (objModal.isPanelEmpty) {
    delete vueObj.ScheduleInterview.panelist;
  }
};
const getTeams = async (vueObj) => {
  const response1 = await getTeamsToken();
  if (response1.status == 200) {
    let token = await response1.data.token;
    axios({
      method: "delete",
      url: `https://graph.microsoft.com/v1.0/users/${vueObj.roleValues.email}/calendar/events/${vueObj.meetingID}`,
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
  }
};
const reschedulewithVccl = async (vueObj) => {
  let payload = {
    roomId: vueObj.ScheduleInterview.roomId,
    startime: vueObj.newDataeVAS,
    endime: vueObj.newDataeEnd,
    Attendees: vueObj.getVcclAttendees(),
  };
  const res = await rescheduleVccl(payload);
  return res.status;
};
const rescheduleInterview = async (vueObj, objModal) => {
  copyToClipboard(vueObj);
  if (vueObj.ScheduleInterview.scheduleButton !== "Reschedule") {
    vueObj.successModal("Interview scheduled successfully");
  } else {
    vueObj.successModal("Interview rescheduled successfully");
  }
  vueObj.ScheduleInterview.externalPanelist = [];
  vueObj.ScheduleInterview.teamsStatus = null;
  vueObj.ScheduleInterview.panelist = null;
  if (vueObj.$route.name == "JdDetails") {
    vueObj.getJobDetails();
  } else {
    vueObj.getCandidates();
  }
  objModal.closeScheduleInterviewModal();
};
const scheduleInterview = async (vueObj, objModal) => {
  await checkSheduleInterview(vueObj, objModal);

  if (!vueObj.ScheduleInterview.errorpanel) {
    if (!vueObj.$v.ScheduleInterview.$invalid) {
      vueObj.showSpinner = true;

      let candidate = {
        name: vueObj.activeCandidate.name,
        email: vueObj.activeCandidate.email,
        phoneNumber: vueObj.activeCandidate.phoneNumber,
        candidateID: vueObj.activeCandidate.candidateID,
      };
      vueObj.ScheduleInterview.candidate = candidate;
      if (
        vueObj.ScheduleInterview.withVccl == true &&
        (vueObj.ScheduleInterview.roomId == "" ||
          vueObj.ScheduleInterview.roomId == undefined)
      ) {
        vueObj.ScheduleInterview.roomId =
          vueObj.ScheduleInterview.vcclResponse.roomId;
        vueObj.ScheduleInterview.meetingLink =
          vueObj.ScheduleInterview.vcclResponse.roomLink;
      }
      vueObj.ScheduleInterview.teams = vueObj.ScheduleInterview.withTeams;

      try {
        const obj = {
          ...vueObj.ScheduleInterview,
          recruiterRemarks: objModal.recruiterRemarks,
        };

        delete obj.errorpanel;
        delete obj.toolTipTitle;
        delete obj.scheduleButton;
        delete obj.schedulename;
        delete obj.storeLink;
        delete obj.storeNoneLink;
        delete obj.storeVcclLink;
        delete obj.requiredPanel;
        delete obj.selectedOption;
        delete obj.vcclResponse;
        delete obj.teamsStatus;
        delete obj.withTeams;
        delete obj.showError;
        delete obj.selectCand;
        if (vueObj.ScheduleInterview.withVccl == true) {
          delete obj.meetingID;
        } else if (vueObj.ScheduleInterview.withTeams == true) {
          delete obj.roomId;
        } else if (
          vueObj.ScheduleInterview.withTeams == false ||
          vueObj.ScheduleInterview.withVccl == false
        ) {
          delete obj.roomId;
          delete obj.meetingID;
        }

        const response = await addScheduleInterview(obj);
        if (response.status == 200) {
          objModal.recruiterRemarks = "";
          vueObj.ScheduleInterview.roomId = "";

          if (
            vueObj.ScheduleInterview.scheduleButton === "Reschedule" &&
            vueObj.meetingID != "" &&
            vueObj.ScheduleInterview.withTeams == true
          ) {
            await getTeams(vueObj);
          }

          vueObj.showSpinner = false;
          vueObj.LoaderStatus = true;

          await rescheduleInterview(vueObj, objModal);
        } else {
          vueObj.showSpinner = false;
        }
      } catch (error) {
        vueObj.LoaderStatus = false;

        vueObj.errorModal(
          "Something went wrong" +
            "please enter" +
            error.response.data.data.status
        );
        objModal.showSpinner = false;
        throw new Error(`Failed! Updating InterView:${error.status}`);
      }
    }
  }
};

const scheduled = async (vueObj, objModal) => {
  try {
    if (
      objModal.isExternalEmpty &&
      objModal.isPanelEmpty &&
      vueObj.ScheduleInterview.date != "" &&
      vueObj.ScheduleInterview.startTime != ""
    ) {
      vueObj.ScheduleInterview.errorpanel = true;
    } else if (!objModal.isExternalEmpty || !objModal.isPanelEmpty) {
      vueObj.ScheduleInterview.errorpanel = false;
    }

    vueObj.clearDetails = true;
    vueObj.$v.ScheduleInterview.$touch();
    if (
      vueObj.ScheduleInterview.withTeams &&
      !vueObj.$v.ScheduleInterview.$invalid &&
      !vueObj.ScheduleInterview.showError &&
      !vueObj.ScheduleInterview.errorpanel
    ) {
      objModal.showSpinner = true;
      vueObj.ScheduleInterview.withVccl = false;
      if (
        vueObj.ScheduleInterview.roomId != "" &&
        vueObj.ScheduleInterview.roomId != undefined
      ) {
        let payload = {
          roomId: vueObj.ScheduleInterview.roomId,
        };
        const res = await cancelVccl(payload);
        if (res.status == 200) {
          await callMethod(vueObj, objModal);
        }
      } else {
        await callMethod(vueObj, objModal);
      }
    } else if (
      vueObj.ScheduleInterview.withVccl &&
      !vueObj.$v.ScheduleInterview.$invalid &&
      !vueObj.ScheduleInterview.showError &&
      !vueObj.ScheduleInterview.errorpanel
    ) {
      objModal.showSpinner = true;

      if (
        (vueObj.ScheduleInterview.scheduleButton === "Reschedule" &&
          (vueObj.ScheduleInterview.roomId == "" ||
            vueObj.ScheduleInterview.roomId == undefined) &&
          vueObj.ScheduleInterview.withVccl == true) ||
        vueObj.ScheduleInterview.scheduleButton === "Schedule"
      ) {
        if (
          vueObj.ScheduleInterview.withVccl == true &&
          vueObj.ScheduleInterview.meetingID != ""
        ) {
          await getTeams(vueObj);
        }

        const vcclStatus = await createmeetingwithVccl(vueObj);
        if (vcclStatus == 200) {
          await scheduleInterview(vueObj, objModal);

          objModal.showSpinner = false;
        }
      } else if (
        vueObj.ScheduleInterview.scheduleButton === "Reschedule" &&
        vueObj.ScheduleInterview.roomId != ""
      ) {
        const res = await reschedulewithVccl(vueObj);
        if (res == 200) {
          objModal.showSpinner = false;

          await scheduleInterview(vueObj, objModal);
        }
      }
    } else if (
      !vueObj.$v.ScheduleInterview.$invalid &&
      !vueObj.ScheduleInterview.showError &&
      !vueObj.ScheduleInterview.errorpanel
    ) {
      objModal.showSpinner = true;
      if (vueObj.ScheduleInterview.roomId != "") {
        let payload = {
          roomId: vueObj.ScheduleInterview.roomId,
        };
        await cancelVccl(payload);
      } else if (vueObj.ScheduleInterview.meetingID != "") {
        await getTeams(vueObj);
      }

      await scheduleInterview(vueObj, objModal);
      objModal.showSpinner = false;
    }
  } catch (error) {
    objModal.showSpinner = false;

    console.error("An error occurred:", error);

    throw error;
  }
};

const callMethod = async (vueObj, objModal) => {
  const response = await getTeamsToken();

  if (response.status == 200) {
    vueObj.teamsToken = await response.data.token;
    const createmeetingStatus = await createmeeting(vueObj);
    if (createmeetingStatus === 201) {
      await scheduleInterview(vueObj, objModal);
      objModal.showSpinner = false;
    }
  }
};
const cancelMeet = async (vueObj) => {
  vueObj.showSpinner = true;
  if (vueObj.meetingID != "" && vueObj.meetingID != undefined) {
    const response1 = await getTeamsToken();
    if (response1.status == 200) {
      let token = await response1.data.token;
      axios({
        method: "delete",
        url: `https://graph.microsoft.com/v1.0/users/${vueObj.roleValues.email}/calendar/events/${vueObj.meetingID}`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then(async (res) => {
          if (res.status == 204) {
            let payload = {
              candidateID: vueObj.cancelCandidate.candidate.candidateID,
              jobID: vueObj.cancelCandidate.jobID,
              customerID: vueObj.cancelCandidate.customerID,
              remarks: "ok",
            };
            const res = await cancelmeeting(payload);
            await getCancelMeetResponse(res, vueObj);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  } else if (vueObj.roomId != "") {
    let payload = {
      roomId: vueObj.roomId,
    };
    const res = await cancelVccl(payload);
    if (res.status == 200) {
      let payload = {
        candidateID: vueObj.cancelCandidate.candidate.candidateID,
        jobID: vueObj.cancelCandidate.jobID,
        customerID: vueObj.cancelCandidate.customerID,
        remarks: "ok",
      };
      const res = await cancelmeeting(payload);
      vueObj.roomId = "";
      vueObj.ScheduleInterview.roomId = "";
      await getCancelMeetResponse(res, vueObj);
    }
  }
};
const getCancelMeetResponse = async (res, vueObj) => {
  if (res.status == 200) {
    vueObj.LoaderStatus = false;
    vueObj.successModal("Meeting cancelled successfully!");
    vueObj.cancelCandidate = {};
    if (vueObj.$route.name == "JdDetails") {
      vueObj.getJobDetails();
    } else {
      vueObj.getCandidates();
    }
    vueObj.showSpinner = false;
    vueObj.$bvModal.hide("cancel-modal");
  }
};

const rescheduled = async (data, vueObj) => {
  vueObj.scheduleModal = true;
  vueObj.ScheduleInterview.toolTipTitle = "Copy";
  vueObj.ScheduleInterview.schedulename = "Reschedule Interview";
  vueObj.ScheduleInterview.scheduleButton = "Reschedule";

  vueObj.activeCandidate = data;
  vueObj.ScheduleInterview.roundlevel = vueObj.activeCandidate.kanbanLevel;
  vueObj.ScheduleInterview.jobID = vueObj.$route.query.jobID;
  vueObj.ScheduleInterview.customerID = vueObj.$route.query.customerID;
  const response = await getScheduledInterview(data.kanbanInterviewID);
  if (response.status == 200) {
    vueObj.showSpinner = false;

    let interview = response.data.data;
    if (interview.interviewRound.meetingID) {
      vueObj.ScheduleInterview.withTeams = true;
      vueObj.ScheduleInterview.withVccl = false;
      vueObj.ScheduleInterview.storeLink = interview.meetingLink;

      vueObj.ScheduleInterview.selectedOption = "Microsoft Teams";
    } else if (interview.interviewRound.roomId) {
      vueObj.ScheduleInterview.withTeams = false;
      vueObj.ScheduleInterview.withVccl = true;

      vueObj.ScheduleInterview.roomId = interview.interviewRound.roomId;
      vueObj.ScheduleInterview.storeVcclLink = interview.meetingLink;

      vueObj.ScheduleInterview.selectedOption = "VCCL";
    } else {
      vueObj.ScheduleInterview.withTeams = false;
      vueObj.ScheduleInterview.withVccl = false;

      vueObj.ScheduleInterview.selectedOption = "None";
      vueObj.ScheduleInterview.storeNoneLink = interview.meetingLink;
    }

    vueObj.ScheduleInterview.meetingLink = interview.meetingLink;

    vueObj.ScheduleInterview.meetingSummary = interview.meetingSummary;

    vueObj.ScheduleInterview.date = String(interview.date).slice(0, 10);
    vueObj.meetingID = interview.interviewRound.meetingID;
    delete vueObj.ScheduleInterview.meetingID;
    vueObj.ScheduleInterview.startTime = interview.startTime;
    vueObj.ScheduleInterview.endTime = interview.endTime;

    if (interview.externalPanelist.length > 0) {
      vueObj.ScheduleInterview.externalPanelist = interview.externalPanelist;
    } else {
      vueObj.ScheduleInterview.panelist = interview.panelist;
      vueObj.addPanelist();
    }
    vueObj.getJobDetails();
    vueObj.$bvModal.show("scheduleModal");
  } else {
    vueObj.errorModal("Something went wrong");
  }
};

const createmeeting = async (vueObj) => {
  return axios({
    method: "post",
    url: `https://graph.microsoft.com/v1.0/users/${vueObj.roleValues.email}/events`,
    data: JSON.stringify({
      subject: `Simplify3x Interview - ${vueObj.$route.query.jobTitle} - ${vueObj.activeCandidate.name} - ${vueObj.ScheduleInterview.startTime}`,
      start: {
        dateTime: vueObj.newDataeVAS,
        timeZone: "UTC",
      },
      end: {
        dateTime: vueObj.newDataeEnd,
        timeZone: "UTC",
      },
      isReminderOn: false,
      body: {
        contentType: "html",
        content: `<html><head><meta http-equiv="Content-Type" content="text/html; charset=utf-8">\r\n<meta name="Generator" content="Microsoft Exchange Server">\r\n<!-- converted from text -->\r\n<style><!-- .EmailQuote { margin-left: 1pt; padding-left: 4pt; border-left: #800000 2px solid; } --></style></head>\r\n<body>\r\n<font size="2"><span style="font-size:11pt;"><div class="PlainText">&nbsp;</div> <div class="PlainText"><h1> Please Join Scheduled Meeting </h1> <h3> Date: ${vueObj.ScheduleInterview.date},  Start time: ${vueObj.ScheduleInterview.startTime}</h3></div></span></font>\r\n</body>\r\n</html>\r\n`,
      },
      attendees: vueObj.getAttendees(),
      isOnlineMeeting: true,
      onlineMeetingProvider: "teamsForBusiness",
      hideAttendees: vueObj.hideAttendees(),
    }),
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${vueObj.teamsToken}`,
    },
  })
    .then((response) => {
      vueObj.ScheduleInterview.meetingLink =
        response.data.onlineMeeting.joinUrl;
      vueObj.ScheduleInterview.meetingID = response.data.id;

      vueObj.showSpinner = false;
      return response.status;
    })
    .catch((error) => {
      vueObj.showSpinner = false;
      vueObj.errorModal("Create meeting failed, try again!");
      throw error;
    });
};
const createmeetingwithVccl = async (vueObj) => {
  let payload = {
    title: `Simplify3x Interview - ${vueObj.$route.query.jobTitle} - ${vueObj.activeCandidate.name} - ${vueObj.ScheduleInterview.startTime}`,
    Attendees: vueObj.getVcclAttendees(),
    startime: vueObj.newDataeVAS,
    endime: vueObj.newDataeEnd,
    description: vueObj.ScheduleInterview.meetingSummary,
    MeetingTimeZone: "(UTC+05:30) Asia/Calcutta",
    type: "schedule",
  };
  const res = await getVcclData(payload);
  vueObj.ScheduleInterview.vcclResponse = res.data;

  return res.status;
};
const history = async (vueObj, data) => {
  vueObj.activeCandidate = data;
  vueObj.LoaderStatus = true;
  vueObj.showSpinner = true;
  try {
    const res = await getFeedbackHistory({
      candidateID: vueObj.activeCandidate.candidateID,
      jobID: vueObj.$route.query.jobID,
    });
    if (res.status == 200) {
      vueObj.showSpinner = false;
      vueObj.feedbackHistory = await res.data.data;
      vueObj.$bvModal.show("history");
    }
    vueObj.showSpinner = false;
    vueObj.LoaderStatus = false;
  } catch (error) {
    vueObj.showSpinner = false;
    vueObj.LoaderStatus = false;
    throw new Error(`Failed! status:${error.status}`);
  }
};

module.exports = {
  createmeeting,
  createmeetingwithVccl,
  directOnHold,
  exportResume,
  rescheduled,
  actionOnnFinalHold,
  getopsHead,
  sendForApproval,
  rejectedscheduleInterviewModal,
  openAssessmentConfigModal,
  getTeamToken,
  candidateSummary,
  reschedulewithVccl,
  cancelMeet,
  panelDetails,
  assignMarksSuccess,
  closemarksSuccess,
  openGiveFeedbackModal,
  shareTestRej,
  savefeedback,
  notInterested,
  scheduled,
  history,
};
